import React from 'react';

import config from '../../config'
import Plot from '../Plot';

function CombinedText({ size, nodes, renderValues, extraRotation }) {
  return (
    <Plot size={size}>
      {({ xScale, yScale }) => nodes.map(({ x, y, data }) => (
        <g className="nodeG" transform={`translate( ${xScale(x)}, ${yScale(y)} )`}>
          {data.filter(reading => reading !== undefined).map((reading, i, list) => {
            const xOffset = i * xScale(config.plot.nodeXSpace) / list.length;
            return (
              <g className="readingG" transform={`translate(${xOffset}, 0)`}>
                {renderValues[i](reading)}
              </g>
            )
          })}
        </g>
      ))}
    </Plot>
  )
}

CombinedText.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
  renderValues: [], // Provide customisation of how the value is rendered
  showEmptySensors: false,
}

export default CombinedText;



// WEBPACK FOOTER //
// ./src/components/CombinedText/CombinedText.component.js